import React from "react";
import UpcomingList from "@/pages/UpcomingList";
export default function UpcomingPayments() {
  return <UpcomingList kind="expense" title="Yaklaşan Ödemeler" subtitle="Bekleyen Giderler" testidPrefix="upay" />;
}
